  
import {
    FETCH_CURRENCY_FAILURE,
    FETCH_CURRENCY_REQUEST,
    FETCH_CURRENCY_SUCCESS, 
    SET_SELECTED_CURRENCY 
  } from '../types';
  
  const initialState = {
    loading: false,
    currencyList: [],
    selectedcurrencyId: null, 
    error: null,
  };
  
  const currencyReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_CURRENCY_REQUEST:
        return { ...state, loading: true };
      case FETCH_CURRENCY_SUCCESS:
        return { ...state, loading: false, currencyList: action.payload };
      case FETCH_CURRENCY_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_CURRENCY:
        return { ...state, selectedcurrencyId: action.payload };
      default:
        return state;
    }
  };
  
  export default currencyReducer